import React from "react"
import { StaticQuery, graphql } from "gatsby"
import styled from "styled-components"
import { LinkH300 } from "../../NormalLink"
import localeData from "../../../locale"

import { currentLocale } from "../../../locale/languages"

import NavBarSubItems from "./NavBarSubItems"

import slugify from "../../../utils/slugify"

const Container = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0 16px;
`

const Item = styled(LinkH300)`
  padding: 0 16px;
  &.active {
    color: ${(props) => props.theme.colors.orange800};
    &:hover {
      color: ${(props) => props.theme.colors.orange800};
    }
  }
  &:hover {
    color: ${(props) => props.theme.colors.black400};
  }
`

const NavbarItems = ({ data, pageContext }) => {
  const { locale } = pageContext
  const setLocaleInUrl = currentLocale !== locale ? `${locale}/` : ""
  const destinations = data.allSanityVacancyCountry.edges.map((edge) => {
    const title = edge.node._rawLocaleTitle[locale]
      ? edge.node._rawLocaleTitle[locale]
      : ""
    return {
      title: title,
      internalLink: `/${setLocaleInUrl}${slugify(title)}`,
      flag: edge.node.flag,
    }
  })
  const tours = data.allSanityToursPage.edges.map((edge) => {
    const title = edge.node._rawLocaleTitle[locale]
      ? edge.node._rawLocaleTitle[locale]
      : ""
    const flag =
      edge.node.destination && edge.node.destination.flag
        ? edge.node.destination.flag
        : null
    const link = setLocaleInUrl
      ? `/${setLocaleInUrl}tours/${slugify(title)}`
      : `/tours/${slugify(title)}`
    return {
      title: title,
      internalLink: link,
      flag: flag,
    }
  })

  const destinationMenu = {
    title: localeData.DESTINATIONS[locale],
    items: destinations,
  }

  const toursMenu = {
    title: localeData.TOURS[locale],
    items: tours,
  }

  const navItems = [
    data.sanityAllVacanciesPage,
    toursMenu,
    destinationMenu,
    data.sanityOurProcessPage,
    data.sanityAboutUsPage,
    data.sanityStoriesPage,
    data.sanityFaqPage,
    data.sanityContactPage,
  ]

  return (
    <Container>
      {navItems &&
        locale &&
        navItems.map((item) =>
          item.title && Array.isArray(item.items) ? (
            item.items.length > 0 && (
              <NavBarSubItems
                key={item.title}
                title={item.title}
                items={item.items}
              />
            )
          ) : (
            <Item
              key={`${item.id}`}
              to={`/${setLocaleInUrl}${slugify(item._rawLocaleTitle[locale])}`}
              activeClassName="active"
            >
              {item._rawLocaleTitle[locale]}
            </Item>
          )
        )}
    </Container>
  )
}

export default (props) => (
  <StaticQuery
    query={graphql`
      query navItems {
        sanityAllVacanciesPage {
          id
          _rawLocaleTitle
        }
        sanityOurProcessPage {
          id
          _rawLocaleTitle
        }
        sanityAboutUsPage {
          id
          _rawLocaleTitle
        }
        sanityStoriesPage {
          id
          _rawLocaleTitle
        }
        sanityFaqPage {
          id
          _rawLocaleTitle
        }
        sanityContactPage {
          id
          _rawLocaleTitle
        }
        allSanityVacancyCountry(sort: { fields: localeTitle___nl }) {
          edges {
            node {
              id
              _rawLocaleTitle
              flag {
                asset {
                  url
                }
              }
            }
          }
        }
        allSanityToursPage {
          edges {
            node {
              id
              _rawLocaleTitle
              destination {
                flag {
                  asset {
                    url
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={(data) => <NavbarItems data={data} {...props} />}
  />
)
